exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.ControlsSection_control-save-button_327w {\n  width: 100%;\n  max-width: 276px;\n}\n@media (max-width: 767px) {\n  .ControlsSection_control-save-button_327w {\n    max-width: inherit;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"control-save-button": "ControlsSection_control-save-button_327w"
};